import React, {useState} from 'react';
import ShowCalendar from './ShowCalendar';
import ShowDayPlanning from './ShowDayPlanning';
import DemoMessage from './DemoMessage';
import BookForm from './BookForm';
import '../../style/booking.css';


export default function Booking() {
  const [serviceType, setServiceType] = useState('');
  const [duration, setDuration] = useState('');
  const [bookPseudo, setBookPseudo] = useState('');
  const [openDay, setOpenDay] = useState({
    disp: false,
    dayName: '',
    day: 0,
    month: '',
    year: '',
  });
  const [bookForm, setBookForm] = useState({
    disp: false,
  })
  const [demoMessage, setDemoMessage] = useState({
    disp: false,
    title: '',
    message: '',
    name: '',
    data: '',
  })

  return (
    <div className="calendar_container noselect">
      <ShowCalendar
        setOpenDay={setOpenDay} />
      {openDay.disp && (
        <ShowDayPlanning
          bookForm={bookForm}
          setBookForm={setBookForm}
          openDay={openDay}
          setOpenDay={setOpenDay} />
      )}
      {bookForm.disp && (
        <BookForm
          bookForm={bookForm}
          setBookForm={setBookForm}
          bookPseudo={bookPseudo}
          setBookPseudo={setBookPseudo}
          duration={duration}
          setDuration={setDuration}
          serviceType={serviceType}
          setServiceType={setServiceType}
          setOpenDay={setOpenDay}
          setDemoMessage={setDemoMessage} />
      )}
      {demoMessage.disp && (
        <DemoMessage
          demoMessage={demoMessage}
          setDemoMessage={setDemoMessage}
          duration={duration}
          setDuration={setDuration}
          serviceType={serviceType}
          setServiceType={setServiceType}
          setBookPseudo={setBookPseudo} />
      )}
    </div>
  );
}

